import "./style.scss";
import * as React from "react";
import _ from "lodash";
import { Legend as reLegend } from "recharts";

export const LegendContents = React.createClass<any, {}>({
  renderLegendItems() {
    //http://jsfiddle.net/hungboypat/wox7cf69/

    let { payload: cells, groupingKey, valueKey } = this.props;
    let items = cells.map((cell: any, index: number) => (
      <li key={`pie-chart-legend-item-${index}`}>
        <div className="icon-border">
          <div className="icon-inner" style={{ backgroundColor: cell.color }} />
        </div>
        &nbsp;&nbsp;&nbsp;
        <span className="label">
          {cell.payload[groupingKey].length == 0
            ? "Undefined"
            : _.startCase(cell.payload[groupingKey])}
        </span>
      </li>
    ));
    return items;
  },

  render() {
    //Hack to hide legend when there's no displayable data
    let items = this.renderLegendItems();
    let hide = { display: items.length == 0 ? "none" : null };

    return (
      <div className="pie-chart-legend" style={hide}>
        <ul>{items}</ul>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./client/modules/core/Chart/RadialChart/Legend/index.tsx